import { axiosInstance } from "@/pages/auth/auth.context";

export interface EmployeeBroadcastRequest {
  /** The employees the admin was looking at, not a filter to re-run server side. */
  userIds: string[];
  subject: string;
  body: string;
  /** ISO instant. Null or omitted sends now. */
  sendAt?: string | null;
}

export interface EmployeeBroadcastResult {
  scheduled: number;
  sendAt: string;
  /** Employees who take neither email nor SMS, so nothing was queued for them. */
  skippedNames: string[];
}

export const employeeBroadcastService = {
  send: async (
    request: EmployeeBroadcastRequest,
  ): Promise<EmployeeBroadcastResult> => {
    const res = await axiosInstance.post<EmployeeBroadcastResult>(
      "employee-broadcast",
      request,
    );
    return res.data;
  },
};
